import { Button, Form, Input, Modal } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConditionDetail from "../../Classes/ConditionDetail";
import { conditionDetailEditorSliceDispatch } from "../../Constants/ReduxConstants";
import FactDropDown from ".././FactDropDown/FactDropDown";
import OperatorDropDown from ".././OperatorDropDown/OperatorDropDown";

function ConditionDetailEditor(props) {
    const fact = useSelector((state: any) => state.conditionDetailEditor.fact);
    const operator = useSelector((state: any) => state.conditionDetailEditor.operator);
    const value = useSelector((state: any) => state.conditionDetailEditor.value);

    const conditionDisabled = useSelector((state: any) => state.ruleModal.conditionDisabled);

    const dispatch = useDispatch()

    const [form] = Form.useForm();
    useEffect(() => {
        form.validateFields(['Fact', 'Operator', 'Value']);
    }, [form]);

    const handleChange = (event: any, newValue?: any) => {

        if (newValue?.id === "fact") {
            dispatch({ type: conditionDetailEditorSliceDispatch.setFact, payload: newValue.value })
        }
        if (newValue?.id === "operator") {
            dispatch({ type: conditionDetailEditorSliceDispatch.setOperator, payload: newValue.value })
        }
        if (event?.target?.id === "value") {
            dispatch({ type: conditionDetailEditorSliceDispatch.setValue, payload: event.target.value })
        }
    }

    async function handleClick() {
        await form.validateFields().then(async () => {
            let newCondition = new ConditionDetail();

            newCondition.andOr = props.conditionToShow?.andOr;
            newCondition.id = props.conditionToShow.id;
            newCondition.fact = fact ?? props.conditionToShow.fact;
            newCondition.operator = operator ?? props.conditionToShow.operator;
            newCondition.value = value ?? props.conditionToShow.value;

            dispatch({ type: conditionDetailEditorSliceDispatch.setFact, payload: null })
            dispatch({ type: conditionDetailEditorSliceDispatch.setOperator, payload: null })
            dispatch({ type: conditionDetailEditorSliceDispatch.setValue, payload: null })

            props.onSaveConditionClick(newCondition)
        });
    }

    return (
        <Modal
            title="Conditions"
            footer={null}
            closable={false}
            open={!conditionDisabled}
            destroyOnHidden={true}
        >
            <Form
                onFinish={handleClick}
                preserve={false}
                form={form}
                initialValues={{
                    ["Fact"]: props.conditionToShow?.fact,
                    ["Operator"]: props.conditionToShow?.operator
                }}
            >
                <Form.Item name="And OR" label="And OR">
                    <Input id="id" placeholder="Id" defaultValue={props.conditionToShow?.andOr} readOnly={true} disabled={true} />
                </Form.Item>
                <Form.Item name="ID" label="ID">
                    <Input id="id" placeholder="Id" defaultValue={props.conditionToShow?.id} readOnly={true} disabled={true} />
                </Form.Item>
                <Form.Item rules={[{ required: true }]} name="Fact" label="Fact">
                    <FactDropDown defaultValue={props.conditionToShow?.fact} onChange={handleChange} />
                </Form.Item>
                <Form.Item rules={[{ required: true }]} name="Operator" label="Operator">
                    <OperatorDropDown defaultValue={props.conditionToShow?.operator} onChange={handleChange} />
                </Form.Item>
                <Form.Item name="Value" label="Value">
                    <Input id="value" placeholder="Value" defaultValue={props.conditionToShow?.value} onChange={handleChange} />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={props.onCancelConditionClick}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}
export default ConditionDetailEditor